import { createReducer, on } from "@ngrx/store";
import { resetStepper, setStepperIndex } from "./stepper.actions";

export const stepperFeatureKey = "stepper";

export interface StepperState {
	stepperIndex: number;
}

export const initialState: StepperState = {
	stepperIndex: 0,
};

export const stepperReducer = createReducer(
	initialState,

	on(setStepperIndex, (state, { data }) => ({
		...state,
		stepperIndex: data,
	})),
	on(resetStepper, () => initialState)

);
